module.exports = __webpack_public_path__ + "img/cocteleria_8.c40c4640.jpeg";